import {
  createLocalCartUuidStore,
  cartStorageKey,
  updateLocalDeliveryAddress,
} from '@iheartjane/cart/utils';
import type { AppMode } from '@iheartjane/types';
import { Storage } from '@iheartjane/utils';

// Adopts the uuid of a cart saved before the flag flipped, so it isn't lost.
// TODO(carts-v3): delete the legacy utils and `storeId` with the Redux slice.
const legacyStoredCartUuid = (appMode: AppMode, storeId?: string | number) =>
  Storage.get<{ uuid?: string }>(cartStorageKey(appMode, storeId))?.uuid ||
  null;

const clearLegacyStoredCart = (appMode: AppMode, storeId?: string | number) =>
  Storage.remove(cartStorageKey(appMode, storeId));

const {
  getLocalCartUuid,
  updateLocalCartUuid: updateStoredCartUuid,
  useLocalCartUuid,
} = createLocalCartUuidStore({
  legacyClear: clearLegacyStoredCart,
  legacyRead: legacyStoredCartUuid,
  // Scoped per partner, like the `-tags` and `-promo-code` keys.
  storageKey: (appMode, storeId) => `${cartStorageKey(appMode, storeId)}-uuid`,
});

// The address only prices this cart, so it goes when the cart does, as v1's
// `clear()` did. Checkout and expiry get here via `useCartState`'s 404.
const updateLocalCartUuid: typeof updateStoredCartUuid = (
  appMode,
  storeId,
  cartUuid
) => {
  if (!cartUuid) updateLocalDeliveryAddress(null);
  updateStoredCartUuid(appMode, storeId, cartUuid);
};

export { getLocalCartUuid, updateLocalCartUuid, useLocalCartUuid };
